import { requireSupabase } from './supabase';

export async function loadActiveMembership(userId) {
  const client = requireSupabase();
  const { data, error } = await client
    .from('organization_members')
    .select('organization_id, role, status, organizations(id, name, slug)')
    .eq('user_id', userId)
    .eq('status', 'active')
    .order('created_at', { ascending: true })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  if (!data) return null;

  return {
    organization: data.organizations,
    organizationId: data.organization_id,
    role: data.role,
    status: data.status,
  };
}

export async function createOrganization(name) {
  const client = requireSupabase();
  const { data, error } = await client.rpc('create_organization', {
    p_name: name.trim(),
  });

  if (error) throw error;
  return data;
}
